// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".thumb-preview[data-v-2e165e56]{background-color:#212121;border:2px solid rgba(0,0,0,.54)}.thumb-preview.dark[data-v-2e165e56]{background-color:#000}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
